import styled from 'styled-components';
import { Col} from 'antd';
const isMobile = window.innerWidth < 768;

export const ScrollableCol = styled(Col)`
  overflow-x: auto;
  white-space: nowrap;
  
  &::-webkit-scrollbar {
    height: 5px;
    
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    width: 9px;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; 
    border-radius: 3px;
    
  }
`;